import React from "react";

import State from "../../../../containers/State";
import { ReactComponent as StateIcon } from "../../../../img/icons/Heredia.svg";
import { CAMPAIGN_2025 } from '../../../../constants';

const stateName = "Heredia";
const stateId = "jFFOuEtDTDEhewnxjM7l";

const Heredia = () => {
  return (
    <State stateName={stateName} stateId={stateId} Icon={StateIcon} year="2025" campaign={CAMPAIGN_2025}>
      <StateIcon />
    </State>
  );
};

export default Heredia;
